var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 102,
    viewBox: "0 0 105 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0753 74H36.1746C34.4214 74 33 72.4008 33 70.4285V27.5714C33 25.599 34.4214 24 36.1746 24H57.5312L72.25 40.5584V70.4285C72.25 72.4008 70.8284 74 69.0753 74Z",
    fill: "url(#paint0_linear_854_6044)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_854_6044)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4669 48.8369H39.7812V62.4733H65.4669V48.8369Z",
    fill: "white",
    fillOpacity: 0.11
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_854_6044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.249 40.5584H68.6008C62.4867 40.5584 57.5303 34.9825 57.5303 28.1042V24L72.249 40.5584Z",
    fill: "url(#paint1_linear_854_6044)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3656 53.1586C34.3609 52.9592 34.4051 52.7633 34.4912 52.6021C34.5941 52.4213 34.7178 52.2647 34.8576 52.1383C35.0693 51.9886 35.2882 51.8585 35.5126 51.7488L36.1675 51.3778L38.7872 49.8705C39.1515 49.6387 39.8301 49.2522 40.8233 48.7111L42.0687 48.0155L42.5166 47.7975L42.5946 47.7512C42.6159 47.745 42.6379 47.745 42.6591 47.7512C42.7094 47.7208 42.7638 47.705 42.8187 47.7048C42.9238 47.6968 43.0289 47.7177 43.128 47.7663C43.2271 47.8149 43.3181 47.8902 43.3956 47.9876C43.4612 48.0722 43.5135 48.1743 43.5491 48.2876C43.5847 48.4009 43.6028 48.5229 43.6025 48.6462V49.8241C43.5993 50.0428 43.5498 50.2554 43.46 50.4363C43.3656 50.6383 43.2247 50.7916 43.0596 50.8723L37.7081 53.8635L43.0596 56.8548C43.2189 56.9447 43.3573 57.0922 43.46 57.2814C43.5533 57.4547 43.6032 57.6645 43.6025 57.8797V59.0577C43.6026 59.1822 43.5843 59.3056 43.5487 59.4203C43.5132 59.5351 43.4611 59.6388 43.3956 59.7254C43.3193 59.8259 43.2287 59.9038 43.1294 59.954C43.0301 60.0043 42.9244 60.026 42.8187 60.0176C42.7641 60.0168 42.71 60.0027 42.6591 59.9759L42.5166 59.9109L42.0687 59.693L40.8335 59.0066L38.7974 57.8519L36.1777 56.3446L35.5228 55.9736C35.3124 55.8577 35.0918 55.7278 34.8678 55.5794C34.7288 55.4909 34.6098 55.3529 34.5232 55.1799C34.4366 55.0069 34.3857 54.8053 34.3758 54.5962L34.3656 53.1586Z",
    fill: "white",
    fillOpacity: 0.18
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.968 60.019C53.7642 60.0239 53.5627 59.9752 53.3838 59.8778C53.205 59.7803 53.0553 59.6375 52.9498 59.464C52.8623 59.339 52.7924 59.2027 52.7421 59.0588L52.6076 58.6983L49.6752 52.253L49.4634 51.7749C49.2191 51.2564 48.7466 50.2274 48.0461 48.688C47.1365 46.7299 46.6816 45.6564 46.6816 45.4673C46.6817 45.3534 46.7079 45.241 46.758 45.1386C46.8081 45.0361 46.8809 44.9463 46.9709 44.8758C47.1741 44.705 47.4339 44.6154 47.6999 44.6247H48.6529C48.8538 44.6212 49.0519 44.6708 49.2272 44.7682C49.4025 44.8658 49.5486 45.0077 49.6508 45.1797L49.8626 45.5848L49.997 45.9453L50.7626 47.6225L52.9294 52.3907L53.2145 52.9983L54.5586 55.9354C55.0738 56.989 55.528 58.0711 55.9189 59.1763C55.9182 59.2896 55.8918 59.4012 55.8418 59.5029C55.7917 59.6046 55.7191 59.6937 55.6297 59.7637C55.4267 59.935 55.1667 60.0246 54.9007 60.0149L53.968 60.019Z",
    fill: "white",
    fillOpacity: 0.18
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7999 60.0171C59.6914 60.0267 59.5826 60.0058 59.4803 59.9556C59.378 59.9055 59.2845 59.8272 59.2054 59.7256C59.0747 59.5492 59.0002 59.3098 58.9981 59.0593V57.884C58.9966 57.6706 59.0441 57.4619 59.134 57.2871C59.2357 57.093 59.3776 56.9447 59.5417 56.8614L64.9162 53.877L59.5417 50.8972C59.3785 50.7999 59.2402 50.6389 59.1442 50.4345C59.0516 50.259 59.0006 50.0491 58.9981 49.8329V48.6392C58.997 48.5171 59.0145 48.3961 59.0496 48.2837C59.0847 48.1715 59.1366 48.0703 59.202 47.9868C59.3617 47.7911 59.5718 47.6897 59.7863 47.7046C59.836 47.7034 59.885 47.7193 59.929 47.7508C59.9582 47.7438 59.9881 47.7438 60.0173 47.7508L60.0887 47.797C60.0683 47.797 60.2109 47.8526 60.5201 48.0145L61.784 48.7086C61.7183 48.6685 62.3978 49.0541 63.8224 49.8654C64.5992 50.3003 65.4893 50.8155 66.4928 51.4108L66.7476 51.5403L67.1145 51.7393C67.3308 51.844 67.5396 51.974 67.7393 52.128C67.882 52.2167 68.0042 52.3574 68.0917 52.5347C68.1793 52.7119 68.2288 52.9186 68.2353 53.132V54.5664C68.2323 54.7631 68.185 54.9537 68.0996 55.1124C68.0046 55.292 67.8816 55.4406 67.7393 55.5473C67.5457 55.6769 67.3181 55.8157 67.0598 55.9638L66.3807 56.334L60.4624 59.7071C60.2925 59.8228 60.1906 59.8968 60.16 59.9246L60.0954 59.9893L59.7999 60.0171Z",
    fill: "white",
    fillOpacity: 0.18
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4443 60.0194V50.7822H39.0201V54.5935H42.2189V50.7822H43.791V60.0194H42.2189V56.2037H39.0201V60.0194H37.4443ZM45.5237 52.3925V50.7822H51.6447V52.3925H49.3629V60.0194H47.8054V52.3925H45.5237ZM53.3701 50.7822H55.3134L57.3659 56.9885H57.4532L59.5057 50.7822H61.4489V60.0194H59.9205V54.0072H59.8586L57.9299 59.9743H56.8891L54.9604 53.9846H54.8985V60.0194H53.3701V50.7822ZM63.4646 60.0194V50.7822H65.0405V58.4092H68.2352V60.0194H63.4646Z",
    fill: "#E8E9ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_854_6044",
    x: 0.78125,
    y: 9.83691,
    width: 103.686,
    height: 91.6367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_854_6044"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_854_6044",
    x: 34.5303,
    y: 0,
    width: 64.7188,
    height: 66.5586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_854_6044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_854_6044",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_854_6044",
    x1: 52.625,
    y1: 24,
    x2: 52.625,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C075EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2BBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_854_6044",
    x1: 64.8896,
    y1: 24,
    x2: 64.8896,
    y2: 40.5584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B051E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#702596"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlIcon);
export default __webpack_public_path__ + "static/media/htmlIcon.da45a1d7dd15186558d14cafb44c2e90.svg";
export { ForwardRef as ReactComponent };